<template>
  <v-row>
    <v-col cols="6">
      <date-picker
        :date-iso.sync="dateIsoLocale"
        :min-date-iso="minDateIso"
        :required="required"
        :readonly="readonly"
        label="Data Envio"
      />
    </v-col>

    <v-col cols="6">
      <time-picker
        :time-iso.sync="timeIsoLocale"
        :min-time-iso="minTimeIso"
        :required="required"
        :readonly="readonly"
        label="Horário Envio"
      />
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch, onMounted, onUnmounted } from '@vue/composition-api'
import DatePicker from '@/components/date-picker/DatePicker.vue'
import TimePicker from '@/components/time-picker/TimePicker.vue'
import { determinarDataMinima, determinarTempoMinimo } from './dateTime'
import { concatenarIsoDateStringETimeStringEmIsoDateTimeString } from '@/utils/dateTime'

export default {
  emits: ['update:dateTimeIso'],

  components: {
    DatePicker,
    TimePicker,
  },

  props: {
    dateTimeIso: {
      type: String,
      default: null,
    },
    required: Boolean,
    readonly: Boolean,
  },

  setup(props, { emit }) {
    const dateIsoLocale = ref(null)
    const minDateIso = ref()
    let minDateIsoInterval = null

    const timeIsoLocale = ref(null)
    const minTimeIso = ref(null)
    let minTimeIsoInterval = null

    onMounted(() => {
      minDateIso.value = determinarDataMinima()
      minTimeIso.value = determinarTempoMinimo(dateIsoLocale.value)

      minDateIsoInterval = setInterval(() => {
        minDateIso.value = determinarDataMinima()
      }, 60 * 1000)

      minTimeIsoInterval = setInterval(() => {
        minTimeIso.value = determinarTempoMinimo(dateIsoLocale.value)
      }, 60 * 1000)
    })

    onUnmounted(() => {
      clearInterval(minDateIsoInterval)
      clearInterval(minTimeIsoInterval)
    })

    watch(
      () => props.dateTimeIso,
      v => {
        if (!v) {
          dateIsoLocale.value = null
          timeIsoLocale.value = null
        } else {
          const [date, time] = v.split('T')
          const [hours, minutes] = time.split(':')

          dateIsoLocale.value = date
          timeIsoLocale.value = `${hours}:${minutes}`
        }
      },
      {
        immediate: true,
      },
    )

    watch(
      dateIsoLocale,
      () => {
        timeIsoLocale.value = null
      },
      {
        deep: true,
      },
    )

    watch(
      () => [dateIsoLocale.value, timeIsoLocale.value],
      ([newDateIso, newTimeIso]) => {
        if (!newDateIso || !newTimeIso) return

        emit('update:dateTimeIso', concatenarIsoDateStringETimeStringEmIsoDateTimeString(newDateIso, newTimeIso))
      },
    )

    return {
      dateIsoLocale,
      minDateIso,
      timeIsoLocale,
      minTimeIso,
    }
  },
}
</script>
